import { DeepLinkRedirectStorageKey } from 'src/helpers/deep-link-redirect-storage-keys';
import { PurchaseStorageKey } from 'src/helpers/purchase-storage-keys';
import { RecentlyViewedClubStorageKey } from 'src/helpers/recently-viewed-club-storage-keys';

export const LocalStorageKeyGroups = {
  recentlyViewedClub: RecentlyViewedClubStorageKey,
  deepLinkRedirect: DeepLinkRedirectStorageKey,
  purchase: PurchaseStorageKey,
} as const;

type DeepValues<T> = T extends string ? T : { [K in keyof T]: DeepValues<T[K]> }[keyof T];

export type LocalStorageKey = DeepValues<typeof LocalStorageKeyGroups>;

export const getLocalStorageItem = (item: LocalStorageKey): string | null => {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem(item);
  }
  return null;
};

export const setLocalStorageItem = (item: LocalStorageKey, itemValue: string) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(item, itemValue);
  }
};

export const removeLocalStorageItem = (item: LocalStorageKey) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(item);
  }
};
